import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('setClauseValue')(function setClauseType(clauseValue, clauseId) {
    store.inboxRulesEditState.clauseMap.get(clauseId).clauseValue = clauseValue;
});
//# sourceMappingURL=setClauseValue.js.map